<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">需要下载任务助手</div>
      <div class="sub-title">现金红包每天更新，团队奖励上不封顶</div>
      <div class="icon">
        <img :src="assistant_icon" alt="">
      </div>
      <div id="download-assistant" data-clipboard-action="copy" class="btn-middle flamingo receive" @click="download()">下载助手</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 289px;
    padding: 30px 0;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .icon {
      height: 72px;
      text-align: center;
      margin-bottom: 30px;

      img {
        width: 72px;
        height: 72px;
        border-radius: 8px;
      }
    }

    .receive {
      margin: 0 auto;
    }
  }
</style>
<script>
  import Dialog from 'components/Dialog'
  import { mapState } from 'vuex'
  import Clipboard from 'clipboard'
  // import { $toast } from '@/views/common/Loading.js'

  export default {
    components: {
      Dialog
    },
    computed: {
      ...mapState({
        assistant_icon: state => state.shoutu.assistant_icon,
        assistant_download_url: state => state.shoutu.assistant_download_url
      })
    },

    data () {
      return {
        btn: ''
      }
    },

    mounted () {
      this.btn = document.getElementById('download-assistant')
      this.clipboard = new Clipboard(this.btn)
    },

    methods: {
      download () {
        let code = 'f37680b9'
        let copyString = 'hb_' + code + '_' + encodeURIComponent(location.search)
        this.btn.setAttribute('data-clipboard-text', copyString)
        // 为 Clipboard 复制内容预留 1s
        setTimeout(() => {
          window.location.href = this.assistant_download_url
        }, 1)
      },

      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      }
    }
  }
</script>
